const TRUE_VALUES = new Set(['1', 'true', 'yes', 'on'])

const parseEnvBoolean = (value, defaultValue = false) => {
  if (value === undefined || value === null || value === '') {
    return defaultValue
  }
  const normalized = String(value).trim().toLowerCase()
  return TRUE_VALUES.has(normalized)
}

const readEnvText = (value, fallback) => {
  const text = String(value ?? '').trim()
  return text || fallback
}

export const webDisabled = parseEnvBoolean(import.meta.env.VITE_WEB_DISABLED, false)
export const webDisableAllowAdmin = parseEnvBoolean(import.meta.env.VITE_WEB_DISABLED_ALLOW_ADMIN, false)
export const webDisableNoticeTitle = readEnvText(import.meta.env.VITE_WEB_DISABLED_TITLE, '网页端已暂停服务')
export const webDisableNoticeMessage = readEnvText(
  import.meta.env.VITE_WEB_DISABLED_MESSAGE,
  '为了提供更稳定的服务，网页端已下线，请使用微信小程序继续使用。'
)

